module.exports = {"noPermissionDefault":"抱歉，您无权限访问此页面"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/utils.json
// module id = ZvLf
// module chunks = 1